function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoCameraTemplate = require('./saito-camera.template');
var SaitoOverlay = require('../saito-overlay/saito-overlay');
var SaitoCamera = /*#__PURE__*/function () {
  function SaitoCamera(app, mod) {
    var _this = this;
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, SaitoCamera);
    this.app = app;
    this.mod = mod;
    this.width = 640;
    this.height = null;
    this.video_elem = null;
    this.cameras = [];
    this.cameraIndex = 0;
    this.facingMode = 'environment'; //user
    this.constraints = {
      audio: false,
      video: {
        deviceId: {}
      }
    };
    this.callback = callback;
    this.overlay = new SaitoOverlay(app, mod);
    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      devices.forEach(function (device) {
        if (device.kind === 'videoinput') {
          _this.cameras.push(device.deviceId);
        }
      });
    });
  }
  return _createClass(SaitoCamera, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      this.overlay.show(SaitoCameraTemplate(), function () {
        _this2.stopStream();
      });
      this.attachEvents();
    }
  }, {
    key: "stopStream",
    value: function stopStream() {
      var stream = this.video_elem.srcObject;
      if (stream) {
        var tracks = stream.getTracks();
        tracks.forEach(function (track) {
          track.stop();
        });
      }
      this.video_elem.srcObject = null;
    }
  }, {
    key: "startStream",
    value: function startStream() {
      var _this3 = this;
      navigator.mediaDevices.getUserMedia(this.constraints).then(function (stream) {
        if (document.querySelector('.saito-camera .saito-loader')) {
          document.querySelector('.saito-camera .saito-loader').remove();
        }
        _this3.video_elem.srcObject = stream;
        _this3.video_elem.play();
      })["catch"](function (err) {
        console.error("An error occurred: ".concat(err));
      });
    }
  }, {
    key: "switchCamera",
    value: function switchCamera() {
      this.stopStream();
      this.cameraIndex++;
      if (this.cameraIndex >= this.cameras.length) {
        this.cameraIndex = 0;
      }
      if (this.cameras.length > 0) {
        this.constraints.video.deviceId.exact = this.cameras[this.cameraIndex];
        this.startStream();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      this.video_elem = document.querySelector('.saito-camera #video');
      var canvas = document.getElementById('canvas');
      var streaming = false;
      this.startStream();
      this.video_elem.addEventListener('canplay', function (ev) {
        if (!streaming) {
          _this4.height = _this4.video_elem.videoHeight / _this4.video_elem.videoWidth * _this4.width;
          _this4.video_elem.setAttribute('width', _this4.width);
          _this4.video_elem.setAttribute('height', _this4.height);
          canvas.setAttribute('width', _this4.width);
          canvas.setAttribute('height', _this4.height);
          streaming = true;
        }
        _this4.clearphoto();
      }, false);
      var startbutton = document.getElementById('startbutton');
      startbutton.onclick = function (ev) {
        _this4.takepicture();
        ev.preventDefault();
      };
      var resetButton = document.getElementById('retake');
      resetButton.onclick = function (e) {
        e.preventDefault();
        _this4.clearphoto();
      };
      var acceptButton = document.getElementById('accept');
      acceptButton.onclick = function (e) {
        e.preventDefault();
        _this4.stopStream();
        _this4.overlay.remove();
        if (_this4.callback) {
          _this4.callback(_this4.data);
        }
      };
      var flipButton = document.getElementById('flip');
      if (flipButton) {
        flipButton.onclick = function (e) {
          _this4.switchCamera();
        };
      }
    }
  }, {
    key: "takepicture",
    value: function takepicture() {
      var canvas = document.getElementById('canvas');
      var photo = document.getElementById('photo-preview');
      var context = canvas.getContext('2d');
      if (this.width && this.height) {
        canvas.width = this.width;
        canvas.height = this.height;
        context.drawImage(this.video_elem, 0, 0, this.width, this.height);
        this.data = canvas.toDataURL('image/png');
        photo.setAttribute('src', this.data);
      } else {
        clearphoto();
      }
      photo.style.display = 'block';
      this.video_elem.style.display = 'none';
      document.querySelector('.saito-camera').classList.remove('video');
    }
  }, {
    key: "clearphoto",
    value: function clearphoto() {
      var canvas = document.getElementById('canvas');
      var context = canvas.getContext('2d');
      var photo = document.getElementById('photo-preview');
      context.fillStyle = '#AAA';
      context.fillRect(0, 0, canvas.width, canvas.height);
      this.data = canvas.toDataURL('image/png');
      photo.setAttribute('src', this.data);
      photo.style.display = 'none';
      this.video_elem.style.display = 'block';
      document.querySelector('.saito-camera').classList.add('video');
    }
  }]);
}();
module.exports = SaitoCamera;